import React from "react";
import "./DalmaWildlifePromo.css";

const DalmaWildlifePromo = () => {
  const handleVisitDalma = () => {
    window.open(
      "https://www.dalmawildlife.com/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <section className="dalma-wildlife-promo" aria-labelledby="dalma-wildlife-promo-title">
      <div className="dalma-wildlife-promo__shell">
        <div className="dalma-wildlife-promo__card">
          <div className="dalma-wildlife-promo__visual">
            <img
              src="/assets/images/dalme-wildlife-website.png"
              alt="Dalma Wildlife Sanctuary tourism preview"
              className="dalma-wildlife-promo__image"
              loading="lazy"
            />
          </div>

          <div className="dalma-wildlife-promo__content">
            <span className="dalma-wildlife-promo__badge">
              Nature • Wildlife • Eco Tourism
            </span>

            <h2
              id="dalma-wildlife-promo-title"
              className="dalma-wildlife-promo__title"
            >
              Explore Dalma Wildlife Sanctuary
            </h2>

            <p className="dalma-wildlife-promo__description">
              Discover wildlife, nature trails, eco-tourism experiences and visitor information through the official Dalma Wildlife website.
            </p>

            <button
              type="button"
              className="dalma-wildlife-promo__cta"
              onClick={handleVisitDalma}
            >
              Visit Official Website
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DalmaWildlifePromo;
